export const REQUEST_WAIT_TIME = 1500; // milliseconds
export const USE_DUMMY_DATA = true;